// src/pages/Services.js
import React from 'react';
import './Services.css';

const Services = () => {
  const servicesList = [
    { title: 'Full Home Interior Design', description: 'Comprehensive design services tailored to your home.' },
    { title: 'Office Design', description: 'Modern and functional designs for workspaces.' },
    { title: 'Customized Furniture', description: 'Unique furniture crafted to match your style.' },
    { title: 'Renovation Projects', description: 'Transform your space with our renovation services.' },
    { title: 'Hotel Interior Design', description: 'Luxurious designs for hotels and resorts.' },
    { title: 'Restaurant Interior Design', description: 'Innovative designs for restaurants and cafes.' },
    { title: 'Retail Store Design', description: 'Attractive designs for retail stores and boutiques.' },
    { title: 'Spa and Salon Design', description: 'Relaxing designs for spas and salons.' },
    { title: 'GYM Interior Design', description: 'Functional and stylish designs for gyms.' },
    { title: 'Landscape Design', description: 'Beautiful designs for outdoor spaces.' },
  ];

  return (
    <div className="services-container">
      <h1>Our Services</h1>
      <p>Explore the wide range of services we offer to enhance your spaces.</p>
      <div className="services-list">
        {servicesList.map((service, index) => (
          <div key={index} className="service-item">
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
